import tmKpMappingData from "./tmKpMappingData.json";

export const mapTmKps = (kp: number, orgId: string) => {
  if ( orgId !== "transmountain_expansion" )
    return kp

  //if org is tm them check for mapping.
  let outputKp
  const kpStr = String(kp)
  if (kpStr in tmKpMappingData) {
    outputKp = `1KP${tmKpMappingData[kpStr as keyof typeof tmKpMappingData]}` // Added second part for type error
  } else {
    outputKp = `2KP${kpStr}`
  }
  return outputKp;
};
